export default __webpack_public_path__ + "static/media/tether.27bbb3c5.webp";